import { render, staticRenderFns } from "./BaseBookPicker.vue?vue&type=template&id=25195aea&scoped=true&"
import script from "./BaseBookPicker.vue?vue&type=script&lang=js&"
export * from "./BaseBookPicker.vue?vue&type=script&lang=js&"
import style0 from "./BaseBookPicker.vue?vue&type=style&index=0&id=25195aea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25195aea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25195aea')) {
      api.createRecord('25195aea', component.options)
    } else {
      api.reload('25195aea', component.options)
    }
    module.hot.accept("./BaseBookPicker.vue?vue&type=template&id=25195aea&scoped=true&", function () {
      api.rerender('25195aea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseBookPicker.vue"
export default component.exports